export default __webpack_public_path__ + "static/media/instagram-footer-preview.48f25c77.png";